/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
(function () {
  'use strict';

  angular.module('comcast.settings.uploadgroup').controller('UploadGroupDetailController', ['$scope', '$rootScope', '$state', '$stateParams', 'UploadGroupResourceFactory', 'NotificationService', '$timeout', 'uiGridConstants', function ($scope, $rootScope, $state, $stateParams, UploadGroupResourceFactory, NotificationService, $timeout, uiGridConstants) {
    /*
     * This is the `vm` object. It is a direct reference to the controller
     * which acts as our 'view-model' in angular. It also limits our need
     * to be accessing $scope directly. */

    /*jshint validthis:true*/
    var vm = this;
    /* BINDABLE : DATA */

    vm.uploadGroup = {};
    vm.originalUploadGroup = {}; // So we can check selectAll values

    /* BINDABLE : METHODS*/

    vm.disableSave = disableSave;
    vm.saveUploadGroupDetails = saveUploadGroupDetails;
    vm.resetUploadGroupDetails = resetUploadGroupDetails;
    vm.validateSpecialCharacters = /^[a-zA-Z0-9!@#$%^&()\[\]{};.\-_~\+]+$/;
    vm.showloader = true;
    /* BINDABLE : DATA */

    vm.gridOptions = {
      enableColumnMenus: false,
      appScopeProvider: vm,
      enableSorting: false,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      rowTemplate: '<div mbl-dblclick="grid.appScope.openDetail(row.entity)" ng-dblclick="grid.appScope.openDetail(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ng-class="{ \'ui-grid-row-header-cell\': col.isRowHeader}"  ui-grid-cell></div>',
      columnDefs: [{
        name: 'fullName',
        field: 'fullName',
        displayName: 'name',
        defaultSort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }, {
        name: 'emailAddress',
        field: 'emailAddress',
        displayName: 'email',
        defaultSort: {
          direction: uiGridConstants.ASC,
          priority: 0
        }
      }]
    };
    /* EVENTS */
    //Register any event listeners

    /* INITIALIZATION */
    //Call controller initialization method here

    _init();
    /* IMPLEMENTATION : BINDABLE */


    function disableSave() {
      if ($scope.uploadGroupDetailForm) {
        if ($stateParams.id == 'new' && $scope.uploadGroupDetailForm.$invalid) {
          return true;
        } else if ($scope.uploadGroupDetailForm.$invalid || !$scope.uploadGroupDetailForm.$dirty) {
          return true;
        }

        return false;
      }
    }

    function isNewUser() {
      return $stateParams.id == 'new';
    }

    function resetUploadGroupDetails() {
      $scope.uploadGroupDetailForm.$setPristine();

      if ($stateParams.id == 'new') {
        vm.uploadGroup = {};
        $scope.uploadGroupDetailForm.$setUntouched();
      } else {
        vm.uploadGroup = angular.copy(vm.originalUploadGroup);
      }
    }

    function saveUploadGroupDetails() {
      if ($stateParams.id == 'new') {
        UploadGroupResourceFactory.create({}, vm.uploadGroup).subscribe(function (uploadGroup) {
          NotificationService.showNotificationToast('Successfully created upload group!');
          $scope.uploadGroupDetailForm.$setPristine();
          $rootScope.uploadGroupDetailForm.$setPristine();
          $state.go('uploadgroupdetails', {
            id: uploadGroup.id
          });
        });
      } else {
        UploadGroupResourceFactory.save({
          id: vm.uploadGroup.id
        }, vm.uploadGroup).subscribe(function () {
          NotificationService.showNotificationToast('Saved Upload group successfully!');
          $scope.uploadGroupDetailForm.$setPristine();
          $rootScope.uploadGroupDetailForm.$setPristine();
          $state.go('uploadgroupdetails', {
            id: vm.uploadGroup.id
          }, {
            reload: true
          });
        });
      }
    }
    /**
     * Initialization for this controller.
     */


    function _init() {
      if ($stateParams.id !== 'new') {
        UploadGroupResourceFactory.get({
          id: $stateParams.id
        }).subscribe(function success(uploadGroup) {
          vm.showloader = false;
          vm.uploadGroup = uploadGroup;
          vm.originalUploadGroup = angular.copy(uploadGroup);
        }, function errorHandler(err) {});
      } else {
        vm.showloader = false;
      }

      $timeout(function () {
        $rootScope.uploadGroupDetailForm = $scope.uploadGroupDetailForm;
      });
    }

    vm.getPage = function (params) {
      params = params !== undefined ? params : {};
      UploadGroupResourceFactory.getUploadGroupUsers(params).subscribe(function success(usersList) {
        vm.gridOptions.data = usersList.rows;
      }, function errorHandler(err) {
        // Something went wrong, so display nothing
        vm.gridOptions.data = [];
      });
    };
    /* EVENTS */
    //Register any event listeners


    $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      // Wait for the current digest cycle to finish, so the grid will display properly
      $timeout(function () {
        // Utilize parameters
        // SearchParams = toParams;
        vm.getPage({
          id: $stateParams.id
        });
      });
    });

    vm.openDetail = function (row) {
      $state.go('userDetails', {
        id: row.id
      });
    };
  }]);
})();